import { AxiosResponse } from 'axios'

import { apisiseci } from './api'

export const getChatbotToken = (): Promise<AxiosResponse> =>
  apisiseci.get('/core/chatbot/token')
